<template>
  <StormFrequencySelector v-model="selectedFrequency" v-model:duration="selectedDuration" :report="report" />
  <div v-if="solutionsData">
    <p>{{ solutionsData.description }}</p>
    <div class="options-container" v-if="currentStormData">
      <div class="option">
        <MarkdownRenderer :content="currentStormData.option_1" />
      </div>
      <div class="divider" />
      <div class="option">
        <MarkdownRenderer :content="currentStormData.option_2" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import StormFrequencySelector from "@/components/StormFrequencySelector.vue";
import MarkdownRenderer from "@/components/MarkdownRenderer.vue";

const props = defineProps({
  report: {
    type: Object,
    required: true,
  },
});

const selectedFrequency = ref(props.report.storm_frequencies[0]?.frequency || 25);
const selectedDuration = ref(props.report.storm_frequencies[0]?.duration || 1440);

const solutionsData = computed(() => {
  const section = props.report.sections.find((section) => section.id === "solutions");
  return section?.content || null;
});

const currentStormData = computed(() => {
  if (!solutionsData.value) return null;

  const matchingStorm = props.report.storm_frequencies.find(
    (storm) => storm.frequency === selectedFrequency.value && storm.duration === selectedDuration.value
  );

  if (!matchingStorm) return null;

  const stormKey = `${selectedFrequency.value}_${selectedDuration.value}`;
  const stormSolutions =
    solutionsData.value.storm_frequencies?.[stormKey] ||
    solutionsData.value.storm_frequencies?.[selectedFrequency.value];

  return stormSolutions || null;
});
</script>

<style lang="scss" scoped>
.options-container {
  display: flex;

  .option {
    flex: 1;
    min-width: 0;
  }

  .divider {
    width: 1px;
    background-color: $color-primary;
    margin: 0 20px;
  }

  @media (max-width: 1850px) {
    flex-direction: column;

    .divider {
      width: 100%;
      height: 1px;
      margin: 20px 0;
    }
  }
}
</style>
